import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var notificationDetailsRes;
export const notificationDetailsTodo = createAsyncThunk('notificationDetails', async (id) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'update_seen_notification',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "notification_id": id,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return notificationDetailsRes = res.data
    } catch (error) {
        return notificationDetailsRes = error.response.data
    }
})


const notificationDetailsSlice = createSlice({
    name: 'notificationDetails',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(notificationDetailsTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('notificationDetails', state.data)
            }
        });
        builder.addCase(notificationDetailsTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default notificationDetailsSlice.reducer; 